<div>

    @if (isTitleShown) {
        <div class="row alert mb-1">
            <h3 class="text-center mb-0">{{title}}</h3>
        </div>
    }

    @if (isSubtitleShown) {
        <div class="row alert mt-0">
            <h5 class="text-center">{{subtitle}} {{enrollmentButtonsText}}</h5>
        </div>
    }

    <div class="text-center">

        <div class="btn-group mr-2" role="group" aria-label="Basic example">
            @for (item of enrollmentButtons; track item) {
                <div class="btn">
                    <a  href="{{item.enrollmentLinkUrl}}">
                        <img class="img-fluid mx-auto" src="{{item.enrollmentButtonUrl}}" >
                        <!-- <img  src="{{item.enrollmentButtonUrl}}" > -->
                    </a>
                </div>
            } @empty {
        
            }
        
        </div>

    </div>

</div> 
